import Pagination from './pagination';
import Loading from './loading';

export {
  Pagination,
  Loading
};
